import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRightFromBracket } from "@fortawesome/free-solid-svg-icons";
import { selectIsGameOver, selectLevel } from "store/game/selectors";
import { exitGame, setTimeIsUp } from "store/game";
import Timeline from "components/Timeline";
import Button from "components/Button";

export default function GlobalTimeline() {
  const dispatch = useDispatch();
  const isGameOver = useSelector(selectIsGameOver);
  const duration = useSelector(selectLevel)?.globalTime;

  const handleTimeout = () => {
    if (isGameOver) return;
    dispatch(setTimeIsUp(true));
  };

  return (
    <div className="flex h-10 gap-2">
      <div className="flex-grow">
        <Timeline
          className="h-10 rounded"
          enabled={!isGameOver}
          duration={duration}
          onEnd={handleTimeout}
        />
      </div>
      <Button
        className="flex bg-transparent gap-2 h-full items-center border-violet-500 border rounded px-2 hover:shadow-2xl  cursor-pointer hover:bg-violet-500 duration-200"
        onClick={(e) => {
          dispatch(exitGame());
        }}
      >
        <h3 className="text-md">Çıxış</h3>
        <FontAwesomeIcon icon={faArrowRightFromBracket} />
      </Button>
    </div>
  );
}
